import React, { FunctionComponent, useState } from 'react';
import {Page, useForm,} from 'b302-frontend-library';
import HanButton from '../../utils/HanButton';
import HanCheckbox from '../../utils/HanCheckbox';
import HanPagination from '../../utils/HanPagination';
import HanTable, { HanTableContainer, HanTableHead, HanTableRow, HanTableCell } from '../../utils/han-table-components/HanTable';
import HanTabs, { HanTab } from '../../utils/han-tabs-components/HanTabs';
import SocialMediaIcons from '../../utils/SocialMediaIcons';

interface Props { }

interface UserForm {
    name: string;
    age: string;
    gender: string;
}


const Home: FunctionComponent<Props> = () => {
    const [checkbox, setCheckbox] = useState<boolean>(true);

    const [form, onFormChange] = useForm<UserForm>(f => ({
        name: f.input(''),
        age: f.input(''),
        gender: f.input('')
    }));

    const submitForm = () => {
        console.log(form.values);
    };

    /**
     * HanPagination.tsx demo functions
     **/
    const onPageChange = (page: number) => {
        setCurrentPage(page)
    }
    const [currentPage, setCurrentPage] = useState<number>(0);
    const pageCount = 15;

    return (
        <Page>
            <div style={{ padding: 30 }}>
                {/*<HanSearch*/}
                {/*    id={'name'}*/}
                {/*    value={form.values.name}*/}
                {/*    onChange={onFormChange}*/}
                {/*/>*/}

                <br></br>
                <br></br>

                {/*<HanSelect*/}
                {/*    onChange={onFormChange}*/}
                {/*    placeholder="ABC">*/}
                {/*    <Option value={'A'}>A</Option>*/}
                {/*    <Option value={'B'}>B</Option>*/}
                {/*    <Option value={'B'}>C</Option>*/}
                {/*</HanSelect>*/}

                <br></br>

                <HanButton
                    onClick={submitForm}
                    disabled={false}
                >
                    Opslaan
                </HanButton>

                <br></br>
                <br></br>

                <HanButton
                    onClick={submitForm}
                    disabled={true}
                >
                    Opslaan
                </HanButton>

                <br></br>
                <br></br>

                <HanButton
                    onClick={submitForm}
                    disabled={false}
                    modifiers="black"
                >
                    A
                </HanButton>

                <br></br>
                <br></br>

                <HanCheckbox
                    onClick={() => setCheckbox(!checkbox)}
                    checked={checkbox}
                />

                <SocialMediaIcons
                    instagram="https://www.instagram.com/b302nl/"
                    facebook="https://www.facebook.com/BuroMediaMob/"
                    website="https://b302.nl/"
                    twitter="/"
                />

                <HanPagination
                    onPageChange={onPageChange}
                    currentPage={currentPage}
                    pageCount={pageCount}
                />

                <br />

                <HanTableContainer>
                    <HanTableHead>
                        Was accommodation provided through a housing service from the university?
                    </HanTableHead>
                    <HanTable borderOrientation="horizontal">
                        <HanTableRow>
                            <HanTableCell modifiers="left">Center-aligned cell</HanTableCell>
                            <HanTableCell modifiers={["left", "mine-shaft", "bold"]}>3</HanTableCell>
                            <HanTableCell modifiers={["mine-shaft"]}>3</HanTableCell>
                            <HanTableCell modifiers={["right", "mine-shaft"]}>3</HanTableCell>
                        </HanTableRow>
                        <HanTableRow>
                            <HanTableCell modifiers={["left", "bold"]}>Left-aligned cell</HanTableCell>
                            <HanTableCell modifiers={["mine-shaft"]}>3</HanTableCell>
                            <HanTableCell modifiers={["brownish-grey"]}>3</HanTableCell>
                            <HanTableCell modifiers={["brown-grey"]}>3</HanTableCell>
                        </HanTableRow>
                        <HanTableRow>
                            <HanTableCell modifiers="left">Right-aligned cell </HanTableCell>
                            <HanTableCell modifiers={["mine-shaft"]}>3</HanTableCell>
                            <HanTableCell modifiers={["brownish-grey"]}>3</HanTableCell>
                            <HanTableCell modifiers={["brown-grey"]}>3</HanTableCell>
                        </HanTableRow>
                    </HanTable>
                </HanTableContainer>

                <br />

                <HanTabs title="XYZ">
                    <HanTab title="XYZ">
                        <p>XYZ</p>

                        {/*<HanDropdown greyText="3" placeholder={'Dropdown 1'} onChange={() => null}>*/}
                        {/*    <Option value={'lol'}>lol</Option>*/}
                        {/*</HanDropdown>*/}
                    </HanTab>
                    <HanTab title="ABC">
                        <p>ABC</p>
                    </HanTab>
                </HanTabs>

                <br></br>
                <br></br>
                <br></br>
            </div>
        </Page>
    );
};

export default Home;
